/* SPDX-License-Identifier: AGPL-3.0-or-later */

import { Component, OnInit } from '@angular/core';
import { TournamentEndpointService, TournamentListDto } from '@api';

@Component({
  selector: 'app-tournaments',
  templateUrl: './tournaments.component.html',
  styleUrls: ['./tournaments.component.scss'],
})
export class TournamentsComponent implements OnInit {
  tournaments: TournamentListDto[] = [];

  constructor(private tournamentService: TournamentEndpointService) {}

  ngOnInit() {
    this.loadTournaments();
  }

  getTournaments(): TournamentListDto[] {
    return this.tournaments;
  }

  private loadTournaments() {
    this.tournamentService.tournaments().subscribe({
      next: data => {
        this.tournaments = data;
      },
      error: err => {
        console.error('Failed to load tournaments', err);
      },
    });
  }

  onTournamentDeleted() {
    this.loadTournaments();
  }
}
